import { motion, AnimatePresence } from "framer-motion";
import ImageHeading from "../components/ui/ImageHeading";
import headerImage from "../assets/header/header.jpeg";

import AdministrationCard from "../components/ui/Card/AdministrationCard";
import useAxiosPublic from "../hooks/useAxiosPublic";
import { useQuery } from "@tanstack/react-query";
import LoadingPage from "../components/Layout/LoadingPage";

// Replace schoolTabs with facultyData
const Administration = () => {
  const axiosPublic = useAxiosPublic();

  const {
    data: administrationData,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["administrationData"],
    queryFn: async () => {
      const res = await axiosPublic.get("/discover-zums/administration");
      return res?.data?.data;
    },
  });
  console.log(administrationData, "administration");
  if (isLoading) {
    return <LoadingPage />;
  }

  if (error) {
    return (
      <div className="text-center py-20 text-red-500">Error loading data</div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-gray-100 to-gray-200">
      <ImageHeading heading="Administration" imageUrl={headerImage} />

      <div className="container px-4 py-6 mx-auto sm:py-12 sm:px-6 lg:px-8">
        <motion.div className=" grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {administrationData?.heads?.map((faculty) => (
            <AnimatePresence key={faculty.name}>
              <div className=" cursor-pointer">
                <AdministrationCard {...faculty} />
              </div>
            </AnimatePresence>
          ))}
        </motion.div>

        <h2 className="text-center mb-8 font-domine font-bold text-primary text-2xl md:text-4xl">
          Administrations & Office
        </h2>
        {/* Faculty Grid */}
        <motion.div
          layout
          className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4"
        >
          <AnimatePresence>
            {administrationData?.staffs?.map((faculty) => (
              <div key={faculty.name} className="cursor-pointer">
                <AdministrationCard {...faculty} />
              </div>
            ))}
          </AnimatePresence>
        </motion.div>
      </div>
    </div>
  );
};

export default Administration;
